import { DestroyRef, Directive, inject, input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { Client } from '@df/core/service/client';
import { filter, merge } from 'rxjs';
import { NOffCanvas } from './off-canvas.interface';
import { OffCanvasService } from './off-canvas.service';

export class OffCanvasItemContext<T, C> {
    constructor(
        public $implicit: T,
        public count: C
    ) {}
}

@Directive({
    selector: 'ng-template[offCanvasItem]',
    standalone: true
})
export class OffCanvasItemDirective implements OnInit {
    item = input.required<NOffCanvas.IMenuItem>({ alias: 'offCanvasItem' });
    item$ = toObservable(this.item);

    protected readonly templateRef = inject(TemplateRef<OffCanvasItemContext<NOffCanvas.IMenuItem, number>>);
    protected readonly viewContainer = inject(ViewContainerRef);
    protected readonly offCanvasService = inject(OffCanvasService);
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly client = inject(Client);

    ngOnInit(): void {
        merge(this.item$, this.offCanvasService.data$.pipe(filter(data => !!data)))
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.update());
    }

    protected update() {
        const item = this.item();

        if (!item) {
            return;
        }

        const count =
            this.offCanvasService.data()?.categories.find(category => category.url === item.link && !category.visited)?.count || 0;

        this.viewContainer.clear();
        this.viewContainer.createEmbeddedView(
            this.templateRef,
            new OffCanvasItemContext<NOffCanvas.IMenuItem, number>(item, count) // context
        );

        if (this.client.mode !== 'browser') {
            return;
        }

        this.offCanvasService.markVisited(item.link);
    }
}
